import React from 'react';
import { Calendar, RefreshCw } from 'lucide-react';

const ResetNotification = ({ nextResetDate }) => {
  const formatDate = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    })?.format(date);
  };

  const getDaysUntilReset = () => {
    const now = new Date();
    const diffTime = nextResetDate - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysUntilReset = getDaysUntilReset();

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <div className="flex items-start space-x-3">
        <div className="bg-blue-600 rounded-full p-2 flex-shrink-0">
          <RefreshCw className="w-5 h-5 text-white" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 mb-1">Usage Limits Reset Soon</h3>
          <div className="flex items-center space-x-2 text-sm text-gray-700">
            <Calendar className="w-4 h-4" />
            <span>
              Your monthly limits will reset on <strong>{formatDate(nextResetDate)}</strong>
              {daysUntilReset > 0 && (
                <span className="ml-1">({daysUntilReset} {daysUntilReset === 1 ? 'day' : 'days'} remaining)</span>
              )}
            </span>
          </div>
          <p className="text-sm text-gray-600 mt-2">
            All usage counters will reset to zero at the start of next month.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetNotification;